import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-32 border-t border-white/5 bg-[#0a0b0e]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-full bg-[#FF4433] grid place-items-center relative">
              <span className="font-display font-black text-white text-base leading-none">B</span>
              <span className="absolute -bottom-0.5 -right-0.5 w-2 h-2 rounded-full bg-[#F4F2EC]" />
            </div>
            <div className="leading-none">
              <div className="font-display font-black text-[15px] tracking-[0.02em]">BABA MEDIA</div>
              <div className="text-[9px] tracking-[0.28em] text-kyro-faint uppercase mt-0.5">Premium Subscriptions</div>
            </div>
          </div>
          <p className="text-sm text-kyro-mute leading-relaxed">
            Every premium subscription, one vault. Verified sources, quick delivery, and human support that actually replies.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" className="w-9 h-9 grid place-items-center rounded-full border border-white/10 hover:bg-white/5"><Twitter className="w-4 h-4" /></a>
            <a href="#" className="w-9 h-9 grid place-items-center rounded-full border border-white/10 hover:bg-white/5"><Instagram className="w-4 h-4" /></a>
            <a href="mailto:ankitsharmap05@gmail.com" className="w-9 h-9 grid place-items-center rounded-full border border-white/10 hover:bg-white/5"><Mail className="w-4 h-4" /></a>
          </div>
        </div>
        <div>
          <div className="kyro-overline mb-4">Shop</div>
          <ul className="space-y-3 text-sm text-kyro-mute">
            <li><Link to="/shop?category=ott" className="hover:text-kyro-ink">OTT & Streaming</Link></li>
            <li><Link to="/shop?category=ai" className="hover:text-kyro-ink">AI Tools</Link></li>
            <li><Link to="/shop?category=productivity" className="hover:text-kyro-ink">Productivity</Link></li>
            <li><Link to="/shop?category=vpn" className="hover:text-kyro-ink">VPN & Security</Link></li>
            <li><Link to="/shop?category=music" className="hover:text-kyro-ink">Music</Link></li>
          </ul>
        </div>
        <div>
          <div className="kyro-overline mb-4">Company</div>
          <ul className="space-y-3 text-sm text-kyro-mute">
            <li><Link to="/track" className="hover:text-kyro-ink">Track order</Link></li>
            <li><Link to="/#faq" className="hover:text-kyro-ink">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-kyro-ink" data-testid="footer-contact-link">Contact us</Link></li>
            <li><Link to="/terms" className="hover:text-kyro-ink" data-testid="footer-terms-link">Terms & Conditions</Link></li>
            <li><Link to="/refund" className="hover:text-kyro-ink" data-testid="footer-refund-link">Cancellation & Refunds</Link></li>
          </ul>
        </div>
        <div>
          <div className="kyro-overline mb-4">Get in touch</div>
          <ul className="space-y-3 text-sm text-kyro-mute">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#FF4433]" /><span>Shop No. 19, New Life CHS,<br/>Mumbai, Maharashtra — 400064</span></li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 shrink-0 text-[#FF4433]" /><a href="tel:+919924731282" className="hover:text-kyro-ink">+91 99247 31282</a></li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 shrink-0 text-[#FF4433]" /><a href="mailto:ankitsharmap05@gmail.com" className="hover:text-kyro-ink">ankitsharmap05@gmail.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-kyro-faint">
          <p>© {new Date().getFullYear()} BABA MEDIA. All rights reserved.</p>
          <p>Made for people who don't buy anything twice.</p>
        </div>
      </div>
    </footer>
  );
}
